import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useEnrollExistingPatient = (options = {}) => {
  const res = useMutation(
    (dto) =>
      http.get(
        HTTP_ENDPOINTS.patientFiIntegration.enrollExistingPatient({
          patientId: dto.patientId,
          account: dto.account,
        }),
      ),
    { ...options },
  );

  return res;
};
